import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export function exportExcel(filename, columns, rows) {
  const data = rows.map((r) => {
    const o = {};
    columns.forEach((c) => (o[c.header] = c.value(r)));
    return o;
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Données");
  XLSX.writeFile(wb, `${filename}.xlsx`);
}

export function exportPDF(title, columns, rows) {
  const doc = new jsPDF();
  doc.setTextColor(212, 175, 55);
  doc.setFontSize(18);
  doc.text("TIRAMESSI", 14, 18);
  doc.setTextColor(40);
  doc.setFontSize(12);
  doc.text(title, 14, 27);
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text(new Date().toLocaleString("fr-FR"), 14, 33);
  autoTable(doc, {
    startY: 38,
    head: [columns.map((c) => c.header)],
    body: rows.map((r) => columns.map((c) => c.value(r))),
    headStyles: { fillColor: [20, 20, 20], textColor: [212, 175, 55] },
    styles: { fontSize: 8 },
    alternateRowStyles: { fillColor: [245, 245, 240] },
  });
  doc.save(`${title.replace(/\s+/g, "_")}.pdf`);
}
